@if (initialized) {

  <div class="mx-auto p-2" style="max-width: 45rem;">

    <div class="surface-card p-2 border-round w-full">
      <div class="text-center mb-6">
        <div class="text-color text-3xl font-semibold mb-2">Wichtige Vertragsbestätigungen</div>
        <span class="text-color-secondary text-sm">Bitte klappe die einzelnen Abschnitte auf, um die jeweiligen Dokumente zu prüfen und zu bestätigen. Die Maklervollmacht muss zusätzlich unterzeichnet werden.</span>
      </div>
      <div class="grid">
        <div class="col-12">
          <cross-signatures [signatures]="signatures"
                            [signatureRemovable]="true"
                            (signaturesChange)="handleSignatureChanges($event)">
          </cross-signatures>
        </div>
      </div>
    </div>

    <div class="flex justify-content-between col-12 py-4">

      <div>
        <p-button [disabled]="busy" (click)="navigatePreviousStep(4)" label="Zurück" severity="secondary" [text]="true" iconPos="left" icon="pi pi-arrow-left"></p-button>
      </div>

      <div>
<!--        <p-button [disabled]="!signaturesComplete" (click)="finalizeRegistration()" label="Abschließen" icon="pi pi-arrow-right" iconPos="right"></p-button>-->
<!--        <p-button [disabled]="!signaturesComplete" (click)="updateSignatures()" label="weiter" icon="pi pi-arrow-right" iconPos="right"></p-button>-->
        <app-button [disabled]="!signaturesComplete"
                    [busy]="busy"
                    (onClick)="updateSignatures()">
        </app-button>
      </div>

    </div>

  </div>
}
